"use client";

import type { ReactNode } from "react";

/**
 * The shared card shell every engine visual renders.
 *
 * Each component had its own copy of this chrome — the same surface tokens, the
 * same header row, the same title/subtitle/badge arrangement — which put ~25
 * lines of identical markup inside every component body and pushed several of
 * them past the function-length ceiling. Owning it once keeps a component's own
 * file about the thing it visualizes.
 */
export function EngineVisualCard({
  ariaLabel,
  title,
  subtitle,
  badge,
  children,
}: {
  ariaLabel: string;
  title: ReactNode;
  subtitle?: ReactNode;
  badge?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div
      className="w-full rounded-2xl border border-border-default bg-surface-raised p-5 shadow-card transition-all sm:p-6"
      aria-label={ariaLabel}
    >
      <div className="mb-5 flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
        <div>
          <h3 className="text-base font-semibold tracking-tight text-text-primary sm:text-lg">
            {title}
          </h3>
          {subtitle ? <p className="mt-0.5 text-xs text-text-secondary sm:text-sm">{subtitle}</p> : null}
        </div>
        {badge}
      </div>
      {children}
    </div>
  );
}
